import React from 'react';
import Pluralize from 'pluralize';
import * as Routes from 'modules/routes';
import I18n from '@/modules/i18n';
import Text from '@/components/ui/Text';
import styles from './index.module.scss';
import { ClassroomType, NotificationType, NotificationTypes, NotificationByDateType } from './types';

interface NotificationLinksProps {
  classroom: ClassroomType,
  notificationId: number;
  notificationType: NotificationTypes;
  programId: number;
}

const NotificationLinks = ({
  classroom, notificationId, notificationType, programId,
}: NotificationLinksProps) => {
  const linkHref = (params = {}) => {
    const linkAssociation = `${notificationType.toLowerCase()}_id`;

    return Routes.teacher_score_path(classroom.id, {
      [linkAssociation]: notificationId,
      program_id: programId,
      ...params,
    });
  };

  const turnedInText = () => {
    const itemOrItems = Pluralize('item', classroom.turned_in_count, false);
    const turnedInString = I18n.t(`${itemOrItems}_turned_in`);

    return (
      <Text size="sm">
        <span className="tw-font-bold">{classroom.turned_in_count}</span>
        {' '}
        {turnedInString}
      </Text>
    );
  };

  return (
    <div className="tw-flex tw-gap-12 tw-items-center">
      <div className="tw-mr-20">
        <Text asChild className="tw-cursor-pointer">
          <a href={linkHref()}>{classroom.name}</a>
        </Text>
      </div>
      <a className="tw-cursor-pointer" href={linkHref()}>
        {turnedInText()}
      </a>
    </div>
  );
};

interface NotificationProps {
  programId: number;
  notification: NotificationType;
}

const Notification = ({ notification, programId }: NotificationProps) => (
  <div className={styles.message}>
    <Text className="mb5" variant="label" weight="bold">{notification.title}</Text>
    {notification.classrooms.map(classroom => (
      <NotificationLinks
        key={notification.id}
        classroom={classroom}
        notificationId={notification.id}
        notificationType={notification.type}
        programId={programId}
      />
    ))}
  </div>
);

interface NotificationsByDateProps {
  programId: number;
  date: NotificationByDateType;
}

const NotificationsByDate = ({ date, programId }: NotificationsByDateProps) => (
  <>
    <div className={styles.date}>{date.date_formatted}</div>
    {date.notifications.map(notification => (
      <Notification
        key={`${notification.id}-${date.date_formatted}`}
        notification={notification}
        programId={programId}
      />
    ))}
  </>
);

export default NotificationsByDate;
